import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ME_USER } from "app/bundles/authorize/shared/user-profile";
import { IGeojsonRequest } from "app/bundles/requests/shared/models/geojsonRequest";
import { Service } from "app/bundles/requests/shared/models/service";
import { FilterService } from "app/bundles/requests/shared/services/filter.service";
import { IconService } from "app/bundles/requests/shared/services/icon.service";
import { UtilService } from "app/bundles/requests/shared/services/util.service";
import { CoreService } from "app/core/core.service";
import { StorageService } from "app/shared/services/storage.service";
import { SelectItem } from "primeng/api";
import { Subscription } from "rxjs";

@Component({
  selector: "app-request-filter",
  templateUrl: "./request-filter.component.html",
  styleUrls: ["./request-filter.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RequestFilterComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  public services: SelectItem[] = [];
  public responsibles: SelectItem[] = [];
  public responsibleGroups: SelectItem[] = [];
  public statuses: SelectItem[] = [];

  constructor(
    public storageService: StorageService,
    private filterService: FilterService,
    private coreService: CoreService,
    private utilService: UtilService,
    public iconService: IconService,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    const requests: IGeojsonRequest = this.storageService.getGeoJsonRequest();
    if (requests) {
      const foundServices: Service[] =
        this.filterService.findServices(requests);
      this.services.push({ label: "Activité...", value: "" });
      if (foundServices && foundServices.length > 0) {
        for (const service of foundServices) {
          this.services.push({ label: service.name, value: service.code });
        }
      }

      const foundStatuses = this.filterService.findStatuses(requests);
      this.statuses.push({ label: "Statut...", value: "" });
      if (foundStatuses && foundStatuses.length > 0) {
        for (const status of foundStatuses) {
          this.statuses.push({ label: status.name, value: status.code });
        }
      }

      const foundResponsibles: string[] =
        this.filterService.findResponsibleUsers(requests);
      if (foundResponsibles && foundResponsibles.length > 0) {
        for (const responsible of foundResponsibles) {
          if (!responsible) {
            this.responsibles.unshift({
              label: "(Aucun responsable assigné)",
              value: "NONE",
            });
          } else {
            if (responsible.includes(ME_USER)) {
              this.responsibles.push({
                label: responsible,
                value: responsible.substring(
                  0,
                  responsible.length - (ME_USER.length + 1),
                ),
              });
            } else {
              this.responsibles.push({
                label: responsible,
                value: responsible,
              });
            }
          }
        }
        this.responsibles.unshift({ label: "Responsable...", value: "" });
      }

      const foundResponsibleGroups: string[] =
        this.filterService.findResponsibleGroups(requests);
      this.responsibleGroups.push({
        label: "Groupe responsable...",
        value: "",
      });
      if (foundResponsibleGroups && foundResponsibleGroups.length > 0) {
        for (const responsibleGroup of foundResponsibleGroups) {
          this.responsibleGroups.push({
            label: responsibleGroup,
            value: responsibleGroup,
          });
        }
      }
    }

    this.subscriptions.add(
      this.coreService.notifyObservable.subscribe((res) => {
        if (
          Object.prototype.hasOwnProperty.call(res, "option") &&
          res.option === "searchFilterParameter"
        ) {
          this.storageService.updateFilters("searchTerm", res.value);
        }
      }),
    );

    this.subscriptions.add(
      this.coreService.resetFilter$.subscribe(() => this.onResetFilter()),
    );

    this.filterRequests();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onResetFilter(): void {
    this.coreService.startSpinner();
    this.storageService.updateFilters("serviceCode", "");
    this.storageService.updateFilters("statusCode", "");
    this.storageService.updateFilters("responsibleUser", "");
    this.storageService.updateFilters("responsibleGroup", "");
    this.coreService.notifyResetSearchBox();
    this.filterRequests();
    this.coreService.stopSpinner();
  }

  onChangeStatus(event, filterType) {
    this.coreService.startSpinner();
    if (filterType === "SERVICE") {
      this.notifyAndUpdateFilter("serviceCode", event.value);
    } else if (filterType === "STATUS") {
      this.notifyAndUpdateFilter("statusCode", event.value);
    } else if (filterType === "RESPONSIBLE") {
      this.notifyAndUpdateFilter("responsibleUser", event.value);
    } else if (filterType === "RESPONSIBLE_GROUP") {
      this.notifyAndUpdateFilter("responsibleGroup", event.value);
    }
    this.filterRequests();
    this.coreService.stopSpinner();
  }

  private notifyAndUpdateFilter(filterType: string, value: any) {
    this.storageService.updateFilters(filterType, value);
    this.coreService.notifyFilterListChange({ filterType, value });
  }

  private filterRequests(): void {
    this.utilService.resetFilter(this.storageService.getGeoJsonRequest());
    this.utilService.resetSelection(this.storageService.getGeoJsonRequest());
    this.utilService.geojsonfilter(
      this.storageService.getGeoJsonRequest(),
      this.storageService.getFilters(),
    );
    this.storageService.notifyComponents();
    this.storageService.notifyMap();
    this.storageService.notifyList();
    this.coreService.notifyRequestUpdate([]);
    this.coreService.notifyResetZoom();
  }

  public getFilters() {
    return this.storageService.getFilters();
  }

  public getIcon(code: string) {
    return this.iconService.getIconName(code);
  }
}
